import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SavedView } from 'app/core/models';
import { RelatedToType } from 'app/shared/enums';
import UrlUtils from 'app/shared/Utils/url.utils';

@Component({
  selector: 'contacts',
  templateUrl: './contacts.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        height: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsComponent extends OnDestroyMixin {
  savedViews: SavedView[];

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.data.pipe(untilComponentDestroyed(this)).subscribe((data) => {
      this.savedViews = data.savedViews.filter(
        (savedView: SavedView) => savedView.related_to_type === RelatedToType.Contact,
      );
      this.checkRedirectToFirstObjectView(this.activatedRoute);
    });

    this.router.events.pipe(untilComponentDestroyed(this)).subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.checkRedirectToFirstObjectView(this.activatedRoute);
      }
    });
  }

  private checkRedirectToFirstObjectView(route: ActivatedRoute): void {
    if (!route.snapshot.firstChild && this.savedViews.length > 0) {
      let savedViewId = UrlUtils.getFromLocalStorage('contactSavedViewId');
      if (savedViewId && this.isSavedViewPresent(+savedViewId)) {
        this.router.navigate(['./', savedViewId, 'table'], { relativeTo: route, queryParamsHandling: 'merge' });
      } else {
        this.router.navigate(['./', this.savedViews[0].id, 'table'], {
          relativeTo: route,
          queryParamsHandling: 'merge',
        });
      }
    }
  }

  private isSavedViewPresent(savedViewId: number): boolean {
    return !!this.savedViews.find((x) => x.id === savedViewId);
  }
}
